import { render } from "./ContentLoader.vue?vue&type=template&id=48ae7488&scoped=true"
import script from "./ContentLoader.vue?vue&type=script&lang=js"
export * from "./ContentLoader.vue?vue&type=script&lang=js"

import "./ContentLoader.vue?vue&type=style&index=0&id=48ae7488&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ae7488"]])

export default __exports__